module.exports = __webpack_public_path__ + "static/media/Cairo-Regular.418ab4d4.ttf";